<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="90%"
			:max-width="1200"
			:min-width="1000"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon class="mr-2">mdi-briefcase-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Detalle Anexo Contrato</p>
						</div>
						<div class="d-flex align-center">
							<v-tooltip bottom
										v-if="contract?.addendum_to_contract_id && (contract.addendum_to_contract_id != $store.state.contracts.contractComponentModalId)">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										outlined
										dark
										small
										color="#959595"
										class="mr-2"
										@click="toParentContract"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small class="mr-2">mdi-briefcase-outline</v-icon>
										<p class="mb-0 caption">Ver Contrato</p>
									</v-btn>
								</template>
								<span>Ver Contrato Asociado</span>
							</v-tooltip>
							<v-menu offset-y v-if="otherContractAddendums">
								<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
									<v-tooltip bottom>
										<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
											<v-btn
												outlined
												dark
												small
												color="#959595"
												class="mr-2 d-flex align-center justify-space-between"
												v-bind="{ ...menuAttrs, ...tooltipAttrs }"
												v-on="{ ...menuOn, ...tooltipOn }"
											>
												<div class="d-flex align-center justify-center flex-grow-1">
													<v-icon dark small class="mr-2">mdi-briefcase-plus-outline</v-icon>
													<p class="mb-0 caption">Otros Anexos</p>
												</div>
												<v-icon dark small class="ml-2">mdi-plus</v-icon>
											</v-btn>
										</template>
										<span>Ver Otros Anexos del Contrato</span>
									</v-tooltip>
								</template>
								<v-list dense class="py-0" style="min-width: 300px">
									<v-list-item dense class="mb-1 px-1" style="min-height: 25px; background: #959595;">
										<div class="d-flex justify-space-between align-center w-100 px-1 mx-1">
											<p class="caption mb-0 font-weight-bold white--text">Anexos de Contrato</p>
											<div class="ml-6 d-flex justify-end align-center">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															color="white"
															class="mb-0"
															small
															@click="startContractAddendum"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small>mdi-plus</v-icon>
														</v-btn>
													</template>
													<span>Crear anexo de contrato</span>
												</v-tooltip>
											</div>
										</div>
									</v-list-item>
									<v-list-item dense class="mb-0 px-0 green" style="min-height: 25px; background: #959595;">
										<v-btn-toggle
											v-model="deletedAddendumShow"
											dense
											class="d-flex flex-row mb-0"
											style="width: 100%"
										>
											<v-btn class="flex-grow-1"
												:color="!deletedAddendumShow ? '#FF1209':''"
												@click.stop="toggleDeletedAddendumShow()">
												<p class="mb-0 caption font-weight-bold" :class="!deletedAddendumShow ? 'white--text':''">Anexos</p>
											</v-btn>
											<v-btn class="flex-grow-1"
												:color="deletedAddendumShow ? '#FF1209':''"
												@click.stop="toggleDeletedAddendumShow()">
												<div class="d-flex flex-column align-start justify-center"
													style="position: relative;">
													<p class="mb-0" style="font-size: 8px; position:absolute; top: -6px; left: 0px;" :class="deletedAddendumShow ? 'white--text':''">Historial</p>
													<p class="mb-0 caption font-weight-bold" :class="deletedAddendumShow ? 'white--text':''">Anexos Eliminados</p>
												</div>
											</v-btn>
										</v-btn-toggle>
									</v-list-item>
									<v-list-item-group color="#524D4D" v-if="contractAddendums.length">
										<v-list-item
											v-for="(addendum, index) in contractAddendums"
											:key="'ass-'+index"
											dense
											@click="$store.commit('contracts/setContractAddendumComponentModalId', addendum.id)"
											style="min-width: 200px"
										>
											<v-list-item-title dense>
												<div class="d-flex justify-space-between align-center item-background-hover">
													<div class="d-flex align-center justify-space-between caption py-1" style="width: 100%" v-if="deletedAddendumShow">
														<div>
															<div style="width: 90px">Ir a Anexo</div>
															<p class="caption mb-0">Eliminado: {{ addendum.deleted_at | toDate  }}</p>
														</div>
														<div class="text-end">
															<b class="text-end" style="flex: 1;">#{{addendum.addendum_index}}</b>
															<p class="caption mb-0">{{ addendum.created_at | toDate }}</p>
														</div>
													</div>
													<div class="d-flex align-center justify-space-between caption py-1" style="width: 100%" v-else>
														<div style="width: 90px">Ir a Anexo</div>
														<div class="text-end">
															<b class="text-end" style="flex: 1;">#{{addendum.addendum_index}}</b>
															<p class="caption mb-0">{{ addendum.created_at | toDate }}</p>
														</div>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
									<v-list-item v-else>
										<div class="d-flex justify-center align-center caption">
											<p class="mb-0">No hay anexos asociados a este contrato</p>
										</div>
									</v-list-item>
								</v-list>
							</v-menu>
							<v-btn
								outlined
								dark
								small
								color="#959595"
								class="mr-2"
								@click="toFullView"
							>
								<v-icon dark small class="mr-2">mdi-briefcase-plus-outline</v-icon>
								<p class="mb-0 caption">Ir a Vista Completa</p>
							</v-btn>
							<v-tooltip>
								<template v-slot:activator="{ on, attrs }">
									<div v-bind="attrs" v-on="on">
										<v-btn
											icon
											dark
											small
											color="#959595"
											@click="toNewWindow"
										>
											<v-icon>mdi-open-in-new</v-icon>
										</v-btn>
									</div>
								</template>
								<span>Abrir en nueva ventana</span>
							</v-tooltip>
							<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
								<v-icon dark>mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
					<ContractDetailComponent :contractId="$store.state.contracts.contractComponentModalId" contractType="addendum"
						@handle-contract-addendums="handleContractAddendums"/>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import ContractDetailComponent from '@/components/Views/Contracts/ContractDetailComponent'
import { addContractAddendum } from '@/helpers/api/contracts'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
  name: 'ContractAddendumComponentModal',
  components: { ContractDetailComponent },
  data: () => ({
		indexModal: + new Date(),
		contract: null,
		otherContractAddendums: null,
		deletedAddendumShow: false
  }),
  computed: {
		contractAddendums(){
			if(this.deletedAddendumShow){
				return this.otherContractAddendums?.filter((item) => item.deleted_at) || []
			}
			return this.otherContractAddendums?.filter((item) => !item.deleted_at) || []
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		toParentContract(){
			this.$store.commit('contracts/setContractComponentModalId', this.contract.addendum_to_contract_id)
		},
		toggleDeletedAddendumShow(){
			this.deletedAddendumShow = !this.deletedAddendumShow
		},
		changeAddendum(addendum_id){
			this.$store.commit('contracts/setContractAddendumComponentModalId', addendum_id)
		},
    closeModal(){
			this.$store.commit('contracts/setContractAddendumComponentModalId', null)
    },
		toFullView(){
			this.$router.push({ name: 'ContractAddendumDetail', query: { id: this.$store.state.contracts.contractAddendumComponentModalId } })
			this.closeModal()
		},
		handleContractAddendums(addendums){
			this.contract = addendums.contract
			this.otherContractAddendums = addendums.parent_contract_addendums
		},
		closeAllPossibleCreatorsModals(){
			this.$store.commit('reports/setReportComponentModalId', {close_all: true})
			this.$store.commit('budget/setBudgetComponentModalId', null)
			this.$store.commit('contracts/setContractComponentModalId', null)
			this.$store.commit('contracts/setContractAddendumComponentModalId', null)

			eventBus.$emit('reloadInformation', {})
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		async startContractAddendum(){
			const confirmed = await confirm('¿Estás seguro de que deseas crear un nuevo anexo para el contrato?')
			if(confirmed){
				this.createContractAddendum()
			}
		},
		toNewWindow(){
			window.open(
				`/built-in-content?type=addendum&id=${this.$store.state.contracts.contractAddendumComponentModalId}`,
				'',
				'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
			);
		},
		async createContractAddendum(){
			const data = {
				contract_id: this.contract.addendum_to_contract_id
			}
			const addendum = await addContractAddendum(data)
			if(addendum.code == 200){
				if(addendum.addendum_notsigned){
					const messageData = {
						message: 'Aún hay anexos pendientes de revisión, antes de iniciar un nuevo anexo todos los anteriores deben haber sido firmados o cancelados.',
						title: 'Anexos sin finalizar',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.setMessage(messageData)
					return null
				}
				this.closeAllPossibleCreatorsModals()
				this.$router.push({ name: 'ContractAddendumDetail', query: { id: addendum.contract_addendum.id } })
				const messageData = {
					message: 'Se ha creado correctamente el anexo.',
					title: 'Anexo Creado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>